require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./data-visualization-data-visualization-with-d-3-display-shapes-with-svg.json") })
        }
      }, "path---data-visualization-data-visualization-with-d-3-display-shapes-with-svg");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---data-visualization-data-visualization-with-d-3-display-shapes-with-svg!./.cache/json/data-visualization-data-visualization-with-d-3-display-shapes-with-svg.json
// module id = 1968
// module chunks = 231608221292675